module.exports = __webpack_public_path__ + "media/images/500Icon-106387fda3a0567fa36303f9d10d30d3.svg";